import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { InputAdornment, TextField, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Link from '@material-ui/core/Link';
import { useHistory } from "react-router-dom";
interface PlannerFieldProps {
    parentClasses: ClassNameMap,
    setValue: any,
    value: string,
    labelText: string,
    lastElement?: boolean,
    description: string,
}

const PlannerLinkFeildBy: React.FC<PlannerFieldProps> = ({
    parentClasses,
    setValue,
    value,
    labelText,
    lastElement,
    description
}) => {
    const history = useHistory();
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };
    const locationredirect = (value:any):void =>{
        history.push('/settings/locations/edit/'+value)
        window.location.reload();
    }
    return (
        <div className={parentClasses.inputRowWithTopBorder}>
            <div className={parentClasses.labelText}>
                <p>Shared by <span className="linkBtn" onClick={(event) => locationredirect(value.split("#")[1])}>{value.split("#")[0]}</span></p> 
            </div>
        </div>
    );
}

export default PlannerLinkFeildBy;